import { render, staticRenderFns } from "./ConsumerRecordHistory.vue?vue&type=template&id=71ee48c7"
import script from "./ConsumerRecordHistory.vue?vue&type=script&lang=js"
export * from "./ConsumerRecordHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports